/**
 * DOM Utilities
 * DOM manipulation and query functions
 */

/**
 * Get Element with validator
 * @param {string} name
 * @returns {Element}
 */
export function getElement(name) {
  if (document.querySelector(name) !== null) {
    return document.querySelector(name);
  }
  return document.getElementById('helper');
}

/**
 * Check Element Have ClassName
 * @param {Element} element
 * @param {string} className
 * @returns {boolean}
 */
export function hasClass(element, className) {
  if (className === null || className === undefined || element === null) {
    return false;
  }
  return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
}

/**
 * Add New Style
 * @param {string} newStyle
 */
export function addNewStyle(newStyle) {
  let styleElement = document.getElementById('styles_js');
  if (!styleElement) {
    styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.id = 'styles_js';
    document.getElementsByTagName('head')[0].appendChild(styleElement);
  }
  styleElement.appendChild(document.createTextNode(newStyle));
}

/**
 * Make Full Screen
 * @param {Element} elem
 */
export function requestFullScreen(elem) {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen) {
    /* Safari */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) {
    /* IE11 */
    elem.msRequestFullscreen();
  }
}

/**
 * Exit Full Screen
 */
export function exitFullScreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

/**
 * Check if fullscreen is active
 * @returns {boolean}
 */
export function isFullscreen() {
  return !!(
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement
  );
}

/**
 * Scroll to element smoothly
 * @param {string|Element} element
 * @param {object} options
 */
export function scrollTo(element, options = {}) {
  const el = typeof element === 'string' ? document.querySelector(element) : element;
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      ...options,
    });
  }
}
